module.exports = __webpack_public_path__ + "static/media/storm-safe-interreg-ns.7426311f.png";